import { render, staticRenderFns } from "./ChatMessageDialog.vue?vue&type=template&id=5a6b22e1&scoped=true&"
import script from "./ChatMessageDialog.vue?vue&type=script&lang=js&"
export * from "./ChatMessageDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessageDialog.vue?vue&type=style&index=0&id=5a6b22e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6b22e1",
  null
  
)

export default component.exports